import { Select } from 'antd';
import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ConsumerSelect = styled(Select)`
  width: 200px;
`;
